import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/articles/src/assets/erfolgreiches-motivationsschreiben-5.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')